import { h } from "preact";
import { InfoCircleOutlined } from "@ant-design/icons";
import { IForm } from "../interfaces/form";

export const FORM_EDIT = ({
  defaultValue = "",
  optionAddress = [],
  optionMachines = [],
  loadingInput,
  onClickVersionInfo,
}: IForm) => {
  return [
    {
      ref: "maintainId",
      name: "maintainId",
      label: "รหัสหมายเลขการซ่อม",
      type: "INPUT",
      span: 12,
      disabled: true,
      defaultValue,
    },
    {
      ref: "deviceId",
      name: "deviceId",
      label: "รหัสหมายเลขเครื่อง",
      type: "INPUT",
      span: 12,
      rules: {
        required: {
          value: true,
          message: "กรุณากรอกรหัสหมายเลขเครื่องให้ถูกต้อง",
        },
      },
    },
    {
      ref: "saleCode",
      name: "saleCode",
      label: "รหัสเซลล์",
      type: "INPUT",
      span: 12,
      disabled: true,
      defaultValue,
    },
    {
      ref: "customerCode",
      name: "customerCode",
      label: "รหัสลูกค้า",
      type: "INPUTSEARCH",
      span: 12,
      loading: loadingInput,
      rules: {
        required: {
          value: true,
          message: "กรุณากรอกรหัสลูกค้าให้ถูกต้อง",
        },
      },
    },
    {
      ref: "itemCode",
      name: "itemCode",
      label: "ItemCode",
      labelExtra: (
        <span
          onClick={onClickVersionInfo}
          style={{ cursor: "pointer", color: "#1890ff", marginLeft: 6, fontSize: 12, fontWeight: 400 }}
        >
          <InfoCircleOutlined style={{ marginRight: 4 }} />
          รายละเอียดเครื่องตัด
        </span>
      ),
      type: "SELECT",
      span: 24,
      dropdownClassName: "select-wrap-option",
      properties: {
        options: optionMachines.map((m) => ({
          ...m,
          displayLabel: `${m.itemCode} - ${m.itemName}`,
        })),
        valueKey: "itemCode",
        labelKey: "displayLabel",
      },
    },
    {
      ref: "versionMachine",
      name: "versionMachine",
      label: "version เครื่องตัด",
      type: "INPUT",
      span: 24,
      disabled: true,
    },
    {
      ref: "address",
      name: "address",
      label: "เลือกที่อยู่จัดส่ง",
      type: "SELECT",
      span: 24,
      rules: {
        required: {
          value: true,
          message: "กรุณากรอกที่อยู่จัดส่งให้ถูกต้อง",
        },
      },
      properties: {
        options: optionAddress,
        valueKey: "addressId",
        labelKey: "addressName",
      },
    },
  ];
};

export const FORM_SEARCH = ({
  optionsChangeDevice = [],
  onSubmitSearch,
}: any) => {
  return [
    {
      ref: "search_maintainChangeId",
      name: "search_maintainChangeId",
      type: "INPUT",
      label: "หมายเลขการเปลื่ยน",
      placeholder: "ตัวอย่าง DMTC2205-0019",
      span: 6,
      onEnter: onSubmitSearch,
    },
    {
      ref: "search_maintainId",
      name: "search_maintainId",
      label: "หมายเลขการซ่อม",
      type: "INPUT",
      placeholder: "ตัวอย่าง DMTH2205-0094",
      span: 6,
      onEnter: onSubmitSearch,
    },
    {
      ref: "search_deviceId",
      name: "search_deviceId",
      label: "หมายเลขเครื่องตัด",
      type: "INPUT",
      placeholder: "ตัวอย่าง TG001140422152207",
      span: 6,
      onEnter: onSubmitSearch,
    },
    {
      ref: "search_customerCode",
      name: "search_customerCode",
      label: "รหัสลูกค้า / ชื่อลูกค้า",
      type: "INPUT",
      placeholder: "ตัวอย่าง TUP-NMI-22-0045",
      span: 6,
      onEnter: onSubmitSearch,
    },
    {
      ref: "search_saleCode",
      name: "search_saleCode",
      label: "รหัสเซลล์",
      type: "INPUT",
      placeholder: "รหัสเซล์",
      span: 6,
      onEnter: onSubmitSearch,
    },
    {
      ref: "search_maintainChangeStatus",
      name: "search_maintainChangeStatus",
      label: "สถานะ",
      placeholder: "สถานะ",
      type: "SELECT",
      span: 6,
      properties: {
        options: optionsChangeDevice,
        valueKey: "value",
        labelKey: "label",
      },
    },
  ];
};
